import { useEffect, useState } from "react";
import moment from "moment";
import Api from "lib/api/httpRequestHelper";
import {
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
} from "@material-ui/core";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import FromToDateField from "components/_refactor/fields/from-to-date";
import HeaderClientes from "components/_refactor/headers/clients";
import StructureFields from "components/_refactor/fields/structure";
import ClearButton from "components/_refactor/button/clear";
import TableNfs from "./components/table-nfs";

const today = new Date().toISOString().slice(0, 10);
const data30DaysAgo = moment(today).subtract(30, "days").format("YYYY-MM-DD");

export default function RelatorioNfs() {
  const [structureFilters, setStructureFilters] = useState({});
  const [structureLoading, setStructureLoading] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [searching, setSearching] = useState(false);
  const [filters, setFilters] = useState({
    startDate: data30DaysAgo,
    endDate: today,
  });
  const [reportList, setReportList] = useState([]);
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(25);
  const [totalRegisters, setTotalRegisters] = useState(0);

  const snackbar = useSnackbar();

  const getReportsList = async ({ page = 0, sizePerPage = 25 }) => {
    setSearching(true);
    try {
      const response = await Api.get(
        "invoice-report-detail",
        "invoice",
        "?page=" + page + "&pageSize=" + sizePerPage,
        true
      );
      setReportList(response?.Result?.ListPedidos || []);
      setTotalRegisters(response?.Result?.TotalRegistros || 0);
      setPage(response?.Result?.Pagina || 0);
      setSizePerPage(sizePerPage);
    } catch (error) {
      snackbar.showMessage(
        "Ocorreu um erro ao buscar os relatórios. Tente novamente.",
        {
          severity: "error",
        }
      );
    } finally {
      setSearching(false);
    }
  };

  const handleGenerateReport = async () => {
    setSearching(true);
    try {
      await Api.post(
        "invoice-report-create",
        "invoice",
        {
          idLoja: structureFilters?.idLoja,
          ...(structureFilters?.idMarca && {
            idMarca: structureFilters?.idMarca,
          }),
          ...(structureFilters?.idCanal && {
            idCanal: structureFilters?.idCanal,
          }),
          ...(structureFilters?.idRepresentante && {
            idRepresentante: structureFilters?.idRepresentante,
          }),
          idGrupoEconomico: structureFilters?.idGrupoEconomico,
          dtIni: filters.startDate,
          dtFim: filters.endDate,
        },
        true
      );
      snackbar.showMessage("Relatório gerado com sucesso.", {
        severity: "success",
      });
      getReportsList({ page: 0, sizePerPage: sizePerPage });
    } catch (error) {
      snackbar.showMessage(
        "Ocorreu um erro ao gerar o relatório. Tente novamente.",
        {
          severity: "error",
        }
      );
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    getReportsList({ page: 0, sizePerPage: sizePerPage });
  }, []);

  const handleClearFilters = () => {
    setClearFilters(true);
    setFilters({});
    setTimeout(() => {
      setClearFilters(false);
    }, 1000);
  };
  return (
    <>
      <HeaderClientes
        section="Relatório de Notas Fiscais"
        subsection="Notas Fiscais"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <StructureFields
                clearFilters={clearFilters}
                onStructureFieldsChange={setStructureFilters}
                disableAll={searching}
                onStructureFieldsLoad={setStructureLoading}
                requiredFields={["economicGroup", "store"]}
                handleSearch={() =>
                  getReportsList({ page: 0, sizePerPage: sizePerPage })
                }
              />
              <FromToDateField
                label="Período"
                initialDate={filters.startDate}
                finalDate={filters.endDate}
                setInitialDate={(value) =>
                  setFilters({ ...filters, startDate: value })
                }
                setFinalDate={(value) =>
                  setFilters({ ...filters, endDate: value })
                }
                disabled={searching || structureLoading.length > 0}
              />
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleGenerateReport()}
                  disabled={
                    searching ||
                    !structureFilters?.idLoja ||
                    !structureFilters?.idGrupoEconomico ||
                    !filters.startDate ||
                    !filters.endDate ||
                    structureLoading.length > 0
                  }
                >
                  {searching ? "Gerando Relatório..." : "Gerar Relatório"}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <ClearButton
                  disable={searching || structureLoading.length > 0}
                  onClick={handleClearFilters}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Grid item xs={12}>
          <TableNfs
            tableData={reportList}
            page={page}
            totalRegistros={totalRegisters}
            onTableChange={(page, sizePerPage) =>
              getReportsList({ page, sizePerPage })
            }
            sizePerPage={sizePerPage}
            reshearch={getReportsList}
          />
        </Grid>
      </Container>
    </>
  );
}
